// 合约errorCode 匹配
export const futuresErrorCodeArray = [
  'BONUS_ACTIVITY_IN_RISK',
  'BONUS_ACTIVITY_JOINED',
  'BONUS_ACTIVITY_NOT_FINISHED',
  'BONUS_ACTIVITY_RECEIVED',
  'BONUS_ACTIVITY_NEED_APPROVAL',
  'BONUS_ACTIVITY_NOT_UNDERWAY',
  'BONUS_ACTIVITY_REWARDS_LIMIT_TOTAL', // 表示领取总额达上限
  'BONUS_ACTIVITY_REWARDS_LIMIT_SUB', // 该任务领取总额达上限
  'ACTIVITY_JOIN_CHECK_FAILED',
  'ACTIVITY_JOINED',
  'ACTIVITY_SIGN_UP_NOT_UNDERWAY',
  'ACTIVITY_NOT_UNDERWAY',
  'ACTIVITY_JOIN_ONCE_LIMIT',
  'CONTRACT_COPY_TRADE_MASTER_CANNOT_PRESET_PLAN_ORDER',
  'CONTRACT_COPY_TRADE_MASTER_ORDER_CATEGORY_ERROR',
  'CONTRACT_COPY_TRADE_MASTER_REMOVE_FOLLOWER_ERROR',
  'CONTRACT_COPY_TRADE_MASTER_REMOVE_FOLLOWER_POSITION_ERROR',
  'CONTRACT_COPY_TRADE_CANCEL_FOLLOWER_POSITION_ERROR',
  'CONTRACT_COPY_TRADE_ALREADY_MASTER_ERROR',
  'CONTRACT_COPY_TRADE_FULL_FOLLOWER_ERROR',
  'CONTRACT_COPY_TRADE_APPLIED_CAN_NOT_COPY_ERROR',
  'BONUS_ACTIVITY_AWARD_POOL_DRAW_OUT', // 当前奖池已抽完，正在补充中
  'BONUS_ACTIVITY_DAILY_LIMIT', // 今日奖品已发完，请明天再来
  'CONTRACT_COPY_TRADE_MASTER_APPLY_FORBIDDEN',
]
// futuresNoMessageErrorCodeArray为futuresErrorCodeArray的子集
export const futuresNoMessageErrorCodeArray = [
  'ACTIVITY_JOIN_CHECK_FAILED',
  'BONUS_ACTIVITY_IN_RISK',
  'BONUS_ACTIVITY_NEED_APPROVAL',
  'ACTIVITY_JOIN_ONCE_LIMIT',
]
const futuresTransforResp = (resp, vueInstance) => {
  try {
    if (resp && !resp.success && !futuresNoMessageErrorCodeArray.includes(resp.errno)) {
      let message
      if (futuresErrorCodeArray.includes(resp.errno || resp.code)) {
        message = vueInstance.$t('futures-error-messages')[resp.errno || resp.code]
        vueInstance.$message.error(message || resp.message)
      }
    }
  } catch (e) {
    console.error('error in futures-transfor-resp', e)
  }
  return resp
}

export default futuresTransforResp
